import React, { useMemo } from 'react';
import { Link, generatePath } from 'react-router-dom';
import { Stack } from '@hub/stack';
import PotentialLink from '@scentregroup/shared/hub-components/potential-link';
import { getProductListingIssue } from '../../helpers/stock-level-issue-messages';
import { displayStringForPriceRange } from '../../helpers/product-price';
import { displayStringForDiscountPercentageRange } from '../../helpers/percentage';
import { stringToSlug } from '../../helpers/slug';
import { generateStoreFrontUrl } from '../../helpers/store';
import ConditionalIssueText from '../conditional-issue-text';
import { CloudinaryImage } from '../../hub-components/cloudinary-image';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// This duplicates what's in /src/client/path.ts of the checkout app
export const PRODUCT = "/shop/product/:shopId/:productId/:productTitle";
export const ProductCard = ({
  product,
  analytics,
  priceRange,
  discountedPriceRange,
  discountPercentageRange,
  onClick
}) => {
  var _shop$retailer, _product$brand, _product$brand2, _product$brand3, _product$brand4, _product$promotions;

  const {
    shop
  } = product;
  const issue = useMemo(() => getProductListingIssue(product === null || product === void 0 ? void 0 : product.issues), [product === null || product === void 0 ? void 0 : product.issues]);
  const storeFrontUrl = generateStoreFrontUrl((_shop$retailer = shop.retailer) === null || _shop$retailer === void 0 ? void 0 : _shop$retailer.sys.id);
  const imgAlt = (_product$brand = product.brand) !== null && _product$brand !== void 0 && _product$brand.name ? "".concat(product.name, " - ").concat((_product$brand2 = product.brand) === null || _product$brand2 === void 0 ? void 0 : _product$brand2.name) : "".concat(product.name);
  const imageSizeBreakpoints = ['(max-width: 400px) 30vw', '(max-width: 450px) 40vw', '(max-width: 600px) 25vw', '(max-width: 710px) 35vw', '(max-width: 1099px) 10vw', '(min-width: 1100px) 15vw', '100vw'];
  const productPath = generatePath("".concat(PRODUCT), {
    productTitle: (_product$brand3 = product.brand) !== null && _product$brand3 !== void 0 && _product$brand3.name ? stringToSlug("".concat(product.brand.name, "-").concat(product.name)) : stringToSlug(product.name),
    productId: product.variantGroupCode,
    shopId: "".concat(shop.id)
  });
  const trackingParams = new URLSearchParams();

  if (analytics !== null && analytics !== void 0 && analytics.queryID) {
    trackingParams.append('aqid', analytics.queryID);
  }

  if (analytics !== null && analytics !== void 0 && analytics.indexName) {
    trackingParams.append('aqin', analytics.indexName);
  }

  if (analytics !== null && analytics !== void 0 && analytics.position) {
    trackingParams.append('aqpos', String(analytics.position));
  }

  return /*#__PURE__*/_jsxs("div", {
    className: style.productCard,
    "data-test-id": "product-card",
    children: [/*#__PURE__*/_jsxs(Link, {
      className: style.productLinkWrapper,
      to: "".concat(productPath, "#").concat(trackingParams.toString()),
      onClick: () => onClick ? onClick() : null,
      children: [/*#__PURE__*/_jsx(CloudinaryImage, {
        ratio: 0.75,
        imageSetOrImage: {
          url: product.image || '',
          type: 'SQUARE',
          alt: imgAlt
        },
        resizeMode: "pad",
        sizes: imageSizeBreakpoints
      }), /*#__PURE__*/_jsx("div", {
        className: style.productName,
        children: (_product$brand4 = product.brand) !== null && _product$brand4 !== void 0 && _product$brand4.name ? /*#__PURE__*/_jsxs(Stack, {
          gap: "spacing-xs",
          "aria-label": "".concat(product.brand.name, " - ").concat(product.name),
          children: [/*#__PURE__*/_jsx("div", {
            "aria-hidden": true,
            children: product.brand.name
          }), /*#__PURE__*/_jsx("div", {
            "aria-hidden": true,
            children: product.name
          })]
        }) : product.name
      }), /*#__PURE__*/_jsxs("div", {
        className: style.pricesWrapper,
        children: [/*#__PURE__*/_jsx("div", {
          className: style.price,
          children: displayStringForPriceRange(discountedPriceRange !== null && discountedPriceRange !== void 0 ? discountedPriceRange : priceRange)
        }), discountedPriceRange && /*#__PURE__*/_jsx("div", {
          className: style.originalPrice,
          children: displayStringForPriceRange(priceRange)
        })]
      }), discountPercentageRange && /*#__PURE__*/_jsx("div", {
        className: style.discount,
        children: displayStringForDiscountPercentageRange(discountPercentageRange)
      })]
    }), ((_product$promotions = product.promotions) === null || _product$promotions === void 0 ? void 0 : _product$promotions[0]) && /*#__PURE__*/_jsx("div", {
      className: style.discount,
      children: product.promotions[0].title
    }), /*#__PURE__*/_jsxs("div", {
      className: style.productRetailer,
      children: ["Sold by\xA0", /*#__PURE__*/_jsx(PotentialLink, {
        href: storeFrontUrl,
        children: shop.name
      })]
    }), issue && /*#__PURE__*/_jsx(ConditionalIssueText, {
      issue: issue,
      wrapperClass: style.issueWrapper
    })]
  });
};
export default ProductCard;